import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "amfe-flexible";
import Vant from "vant";
import "vant/lib/index.css";
import { Locale } from "vant";
import enUS from "vant/lib/locale/lang/en-US";

Locale.use("en", enUS);
Vue.use(Vant);

Vue.config.productionTip = false;

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
